/* THE LINKS ŌMOKOROA — theme.js
   Mobile nav, fade-up reveals, exit-intent popup, GA4 dataLayer events. */
(function () {
  'use strict';

  /* Mobile nav toggle */
  var header = document.querySelector('.site-header');
  var toggle = document.querySelector('.nav-toggle');
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Gentle fade-up on viewport entry */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('.fade-up');
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    targets.forEach(function (t) { io.observe(t); });
  } else {
    targets.forEach(function (t) { t.classList.add('is-visible'); });
  }

  /* Has the visitor already given us their email? (gate unlock = 30 days, signup = 7 days) */
  function hasCookie(n){ return document.cookie.indexOf(n + '=1') !== -1; }
  var gaveEmail = hasCookie('tlo_unlocked') || hasCookie('tlo_subscribed');

  /* Exit-intent popup (desktop, once per session, never if they've already given their email) */
  var modal = document.getElementById('exit-modal');
  if (modal && !gaveEmail && !sessionStorage.getItem('links_exit_shown')) {
    var fire = function (e) {
      if (e.clientY <= 0) {
        modal.classList.add('is-open');
        sessionStorage.setItem('links_exit_shown', '1');
        document.removeEventListener('mouseout', fire);
      }
    };
    document.addEventListener('mouseout', fire);
  }
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-exit-close]')) modal.classList.remove('is-open');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') modal.classList.remove('is-open');
    });
  }

  /* GA4 / GTM dataLayer events: cta_click, signup_start, signup_submit, instagram_click */
  window.dataLayer = window.dataLayer || [];
  function push(evt, extra) {
    var d = { event: evt }; if (extra) for (var k in extra) d[k] = extra[k];
    window.dataLayer.push(d);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a,button'); if (!a) return;
    if (a.matches('[data-track="cta"]')) push('cta_click', { cta_label: (a.textContent || '').trim() });
    if (a.matches('[data-track="instagram"]')) push('instagram_click');
  });
  document.querySelectorAll('[data-signup] form').forEach(function (f) {
    var started = false;
    f.addEventListener('input', function () { if (!started) { started = true; push('signup_start'); } });
    f.addEventListener('submit', function () {
      push('signup_submit');
      try { document.cookie = 'tlo_subscribed=1;path=/;max-age=604800;samesite=lax'; } catch (e) {}
    });
  });

  /* Layered scroll parallax — offsets [data-parallax] elements by a fraction of
     their distance from viewport centre. Ambient float lives on inner .layered__float. */
  if (!reduced) {
    var pxEls = [].slice.call(document.querySelectorAll('[data-parallax]'));
    if (pxEls.length && 'requestAnimationFrame' in window) {
      var ticking = false;
      var updatePx = function () {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        pxEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var delta = (r.top + r.height / 2) - vh / 2;
          var speed = parseFloat(el.getAttribute('data-parallax')) || 0;
          el.style.transform = 'translate3d(0,' + (delta * speed).toFixed(1) + 'px,0)';
        });
        ticking = false;
      };
      var onPxScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(updatePx); } };
      window.addEventListener('scroll', onPxScroll, { passive: true });
      window.addEventListener('resize', onPxScroll, { passive: true });
      updatePx();
    }
  }
})();
